// extracted by mini-css-extract-plugin
export default {"pageHolder":"Modal_pageHolder__XJGsh","modal":"Modal_modal__yQAhj"};